import { render, staticRenderFns } from "./IregularMerchant.vue?vue&type=template&id=1bd054d0&"
import script from "./IregularMerchant.vue?vue&type=script&lang=js&"
export * from "./IregularMerchant.vue?vue&type=script&lang=js&"
import style0 from "./IregularMerchant.vue?vue&type=style&index=0&id=1bd054d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports